/**
 * Organization.readOnly is a boolean from admin-api / desktop-api (see Organization schema).
 * When true, Desktop blocks CRM writes pending migration / rollback.
 */

/** Shown on disabled CRM action controls in the Desktop UI */
export const CRM_READ_ONLY_UI_TOOLTIP = 'This organization is currently in read-only mode'

/**
 * @param {unknown} readOnly — organization.readOnly from API
 * @returns {boolean}
 */
export function isOrganizationCrmReadOnly (readOnly) {
  return readOnly === true
}

/**
 * @param {object|null|undefined} organization — profile._organization
 * @returns {boolean}
 */
export function isProfileOrganizationCrmReadOnly (organization) {
  return isOrganizationCrmReadOnly(organization && organization.readOnly)
}
